import React from 'react';
import { dateListStyle, dateListItemStyle } from './dates.styles.css';

import { fontGroups } from '@zoopla-eng/zds/themes';

type DatesProps = {
    availableFrom?: string | null;
    availableFromLabel?: string | null;
    publishedOn?: string | null;
    publishedOnLabel?: string | null;
};

const Dates: React.FC<DatesProps> = ({
    availableFrom,
    availableFromLabel,
    publishedOn,
    publishedOnLabel
}) => {
    const hasAvailableFrom = availableFrom && availableFromLabel;
    const hasPublishedOn = publishedOn && publishedOnLabel;

    const formatText = (label: string, value: string) => `${label} ${value}`;

    return hasAvailableFrom || hasPublishedOn ? (
        // eslint-disable-next-line jsx-a11y/no-redundant-roles
        <ul className={`${dateListStyle} ${fontGroups.spoon}`} role="list">
            {hasPublishedOn ? (
                <li className={dateListItemStyle}>
                    {formatText(publishedOnLabel, publishedOn)}
                </li>
            ) : null}
            {hasAvailableFrom ? (
                <li className={dateListItemStyle}>
                    {formatText(availableFromLabel, availableFrom)}
                </li>
            ) : null}
        </ul>
    ) : null;
};

export { Dates };
